import { Visibility, VisibilityOff } from "@mui/icons-material";
import {
  Box,
  Checkbox,
  FormControlLabel,
  IconButton,
  MenuItem,
  Typography,
} from "@mui/material";
import { Field, Form, Formik } from "formik";
import parsePhoneNumber from "libphonenumber-js";
import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import "slick-carousel/slick/slick-theme.css";
import "slick-carousel/slick/slick.css";
import * as Yup from "yup";
import SignupSliderIco1 from "../../../../assets/icons/SignupSliderIco1";
import SignupSliderIco2 from "../../../../assets/icons/SignupSliderIco2";
import SignupSliderIco3 from "../../../../assets/icons/SignupSliderIco3";
import SignupSlide1 from "../../../../assets/images/Signup-Slide-1.svg";
import SignupSlide2 from "../../../../assets/images/Signup-Slide-2.svg";
import SignupSlide3 from "../../../../assets/images/Signup-Slide-3.svg";
import CommonButton from "../../../../component/Button";
import CommonTextField from "../../../../component/Input";
import CommonPhoneInput from "../../../../component/PhoneInput";
import SnackBar from "../../../../component/SnackBar";
import { SignUpCall } from "../../../../redux/action/Login";
import { CustomDiv } from "../../../chat-bot/style";
import { CommonGrid2 } from "../../../common-components/StyledComponents";
import { CustomizeSpan, ErrorContent } from "../../../jobs/style";
import { CustomSlider } from "../style";
import DropDownSelect from "../../../../component/Select";
import { platformWhiteLogo } from "../../../../utils/logo";

export default function SignUp() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [buttonLoading, setButtonLoading] = useState({
    disabled: false,
    createLoading: false,
  });
  const [showPassword, setShowPassword] = useState({ old: false, new: false });
  const [snackbarState, setSnackbarState] = useState({
    open: false,
    message: "",
    severity: "",
  });
  const dispatch = useDispatch();
  const settings = {
    dots: true,
    customPaging: (i) => (
      <div style={{ marginTop: "20px" }}>
        {i === currentIndex ? <ActiveDot /> : <InactiveDot />}
      </div>
    ),
    beforeChange: (oldIndex, newIndex) => setCurrentIndex(newIndex),
    infinite: true,
    speed: 1000,
    autoplay: true,
    autoplaySpeed: 3000,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
  };
  const images = [
    {
      title: (
        <>
          Revolutionize Recruiting with &nbsp;
          <SignupSliderIco1 />
          &nbsp; Smart AI Tools`
        </>
      ),
      icon: SignupSlide1,
    },
    {
      title: (
        <>
          Reduce Recruiting &nbsp;
          <SignupSliderIco2 />
          &nbsp;time by 50 %
        </>
      ),
      icon: SignupSlide2,
    },
    {
      title: (
        <>
          AI Assistant for Automation and &nbsp;
          <SignupSliderIco3 />
          &nbsp;Data Analytics
        </>
      ),
      icon: SignupSlide3,
    },
  ];
  const navigate = useNavigate();
  const createValue = {
    agency_name: "",
    username: "",
    email: "",
    password: "",
    confirm_password: "",
    contact_number: "",
    contact_number_country: "",
    rememberMe: false,
  };

  const ActiveDot = () => (
    <svg
      width="24"
      height="4"
      viewBox="0 0 24 4"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="24" height="4" rx="2" fill="white" />
    </svg>
  );

  const InactiveDot = () => (
    <svg
      width="24"
      height="4"
      viewBox="0 0 24 4"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="24" height="4" rx="2" fill="#402D66" />
    </svg>
  );
  const agencyType = [
    {
      title: "Agency Type",
      component: "dropDown",
      titleName: "agency_type",
      placeholder: "Select Agency Type",
      data: [
        { value: "recruiting_agency", name: "Recruiting Agency" },
        { value: "delivery_agency", name: "Delivery Agency" },
        { value: "vms", name: "VMS" },
        { value: "hiring_teams", name: "Hiring Teams" },
        { value: "candidate", name: "Job Seeker" },
      ],
    },
  ];

  const account = [
    {
      title: "Agency Name",
      component: "input",
      titleName: "agency_name",
      placeholder: "Enter your Agency name",
    },
    {
      title: "Username",
      component: "input",
      titleName: "username",
      placeholder: "Enter your Username",
    },
    {
      title: "Email Address",
      component: "input",
      titleName: "email",
      placeholder: "Enter your email",
    },
    {
      title: "Contact Number",
      component: "phone-number",
      titleName: "contact_number",
      placeholder: "Enter Contact Number",
      country: "contact_number_country",
    },
  ];

  const passwordData = [
    {
      title: "Enter Password",
      component: "input",
      titleName: "password",
      placeholder: "Enter your Password",
      type: showPassword.old ? "text" : "password",
      CustomIcon: (
        <IconButton
          onClick={() => handleShowPasswordToggle("old")}
          edge="end"
          tabIndex={-1}
        >
          {showPassword.old ? (
            <VisibilityOff sx={{ fontSize: "20px" }} />
          ) : (
            <Visibility sx={{ fontSize: "20px" }} />
          )}
        </IconButton>
      ),
    },
    {
      title: "Confirm Password",
      component: "input",
      titleName: "confirm_password",
      placeholder: "Re-Enter your Password",
      type: showPassword.new ? "text" : "password",
      CustomIcon: (
        <IconButton
          onClick={() => handleShowPasswordToggle("new")}
          edge="end"
          tabIndex={-1}
        >
          {showPassword.new ? (
            <VisibilityOff sx={{ fontSize: "20px" }} />
          ) : (
            <Visibility sx={{ fontSize: "20px" }} />
          )}
        </IconButton>
      ),
    },
  ];

  const handleShowPasswordToggle = (name) =>
    setShowPassword((prev) => ({ ...prev, [name]: !prev[name] }));

  const validationSchema = Yup.object({
    agency_type: Yup.string().required("Agency Type is required"),
    agency_name: Yup.string().when("agency_type", {
      is: (value) => value !== "candidate",
      then: (schema) => schema.required("Agency Name is required"),
      otherwise: (schema) => schema.notRequired(),
    }),
    username: Yup.string().required("Username is required"),
    email: Yup.string()
      .required("Email is required")
      .matches(
        /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
        "Invalid email address"
      ),
    contact_number: Yup.string()
      .required("Phone number is required")
      .test(
        "is-valid-phone",
        "Phone number is not valid for the selected country",
        function (value) {
          const { contact_number_country } = this.parent;
          if (!value || !contact_number_country?.countryCode) return false;
          const formattedValue = value.startsWith("+") ? value : `+${value}`;
          const phoneNumber = parsePhoneNumber(
            formattedValue,
            contact_number_country.countryCode
          );
          return phoneNumber?.isValid();
        }
      ),

    password: Yup.string()
      .required("New password is required")
      .min(8, "Password must be at least 8 characters")
      .matches(/[A-Z]/, "Must contain at least one uppercase letter")
      .matches(/[a-z]/, "Must contain at least one lowercase letter")
      .matches(/[0-9]/, "Must contain at least one number")
      .matches(/[^A-Za-z0-9]/, "Must contain at least one special character"),
    confirm_password: Yup.string()
      .required("Confirm password is required")
      .oneOf([Yup.ref("password"), null], "Passwords must match"),
  });

  const handleSubmit = async (values) => {
    setButtonLoading((prev) => ({
      ...prev,
      disabled: true,
      createLoading: true,
    }));
    const payload = {
      name: values.username,
      agency_type: values.agency_type,
      email: values.email,
      contact_number: values.contact_number,
      password: values.password,
      confirm_password: values.confirm_password,
      ...(values.agency_type === "candidate"
        ? { organization_name: values.username }
        : { organization_name: values.agency_name }),
    };

    let responseData = null;
    let hasTimedOut = false;

    const timeout = new Promise((resolve) =>
      setTimeout(() => {
        hasTimedOut = true;
        resolve();
      }, 5000)
    );

    await Promise.race([
      (async () => {
        try {
          const data = await dispatch(SignUpCall(payload));
          responseData = data;
        } catch (error) {
          if (!hasTimedOut) {
            setSnackbarState({
              open: true,
              severity: "error",
              message:
                error?.data?.message ||
                error?.message ||
                "Something went wrong",
            });
          }
        }
      })(),
      timeout,
    ]);

    if (responseData || hasTimedOut) {
      const encodedEmail = encodeURIComponent(values.email);
      navigate(`/account-create?email=${encodedEmail}`);
    }

    setButtonLoading((prev) => ({
      ...prev,
      disabled: false,
      createLoading: false,
    }));
  };

  const handleCloseValidation = () => {
    setSnackbarState((prev) => ({
      ...prev,
      open: false,
    }));
  };

  const CustomMenuItem = (item, index) => {
    return (
      <MenuItem value={item.value} key={index}>
        {item?.name}
      </MenuItem>
    );
  };

  return (
    <Box
      backgroundColor={"#FFFFFF"}
      // width={{ xs: "90%", md: "80%" }}
      maxWidth={{ xs: "95%", sm: "95%", md: "90%", lg: "80%", xl: "80%" }}
      margin={{ xs: "2rem auto", sm: "auto", md: "auto" }}
      borderRadius={"10px"}
      flexGrow={1}
      display={"flex"}
      alignItems={"center"}
      minHeight="100vh"
    >
      <CommonGrid2
        container
        width={"100%"}
        borderRadius="15px"
        boxShadow="0px 4px 20px rgba(0, 0, 0, 0.1)"
        flexDirection={{
          xs: "column",
          sm: "row",
          md: "row",
        }}
        alignItems={"center"}
      >
        <CommonGrid2
          item
          size={{ xs: 12, sm: 4, md: 4 }}
          overflow={"hidden"}
          backgroundColor="#2D2044"
          position={"relative"}
          borderRadius={{
            xs: "10px 10px 0 0",
            sm: "10px 0px 0px 10px",
            md: "10px 0px 0px 10px",
          }}
          padding={{
            xs: "1rem",
            sm: "2rem",
            md: "2rem",
          }}
          height={"-webkit-fill-available"}
        >
          <CustomDiv>
            <CustomDiv margin="0px 0px 2rem">
              {platformWhiteLogo()}
            </CustomDiv>
            <CustomSlider {...settings}>
              {images.map((item, index) => (
                <CommonGrid2
                  display={"flex !important"}
                  flexDirection={"column"}
                  gap={"2rem"}
                >
                  <Typography
                    sx={{
                      fontSize: {
                        xs: "1.5rem",
                        sm: "1.5rem",
                        md: "1.8rem",
                      },
                    }}
                    color="#FFFFFF"
                    fontWeight={700}
                  >
                    {item.title}
                  </Typography>
                  <img
                    key={index}
                    src={item.icon}
                    alt={`Slide ${index}`}
                    width={"100%"}
                    height={"100%"}
                  />
                </CommonGrid2>
              ))}
            </CustomSlider>
          </CustomDiv>
        </CommonGrid2>
        <CommonGrid2 item size={{ xs: 12, sm: 8, md: 8 }} padding={"1.5rem"}>
          <Formik
            initialValues={createValue}
            validationSchema={validationSchema}
            onSubmit={handleSubmit}
          >
            {({ values, errors, validateForm, setFieldValue, touched }) => {
              const nameChange = account.map((acc, ind) =>
                (values.agency_type === "vms" ||
                  values.agency_type === "hiring_teams") &&
                acc.titleName === "agency_name"
                  ? {
                      ...acc,
                      title: "Org name",
                      placeholder: "Enter your Org name",
                    }
                  : { ...acc }
              );
              const accountData =
                values.agency_type === "candidate"
                  ? [...agencyType, ...account.slice(1)]
                  : [...agencyType, ...nameChange];

              return (
                <Form
                  onKeyDown={(e) => {
                    if (e.key === "Enter") e.preventDefault();
                  }}
                >
                  <CommonGrid2
                    display={"flex"}
                    flexDirection={"column"}
                    gap={"1rem"}
                  >
                    <Typography
                      textAlign="left"
                      fontWeight={700}
                      variant="h1"
                      color="#223548"
                    >
                      Create an account?
                    </Typography>
                    <Typography variant="body4">Get started !</Typography>
                  </CommonGrid2>

                  <CommonGrid2 container spacing={2.5} marginTop={3}>
                    {accountData?.map((item, index) => {
                      return (
                        <CommonGrid2
                          item
                          size={{
                            xs: 12,
                            md: 6,
                            sm: 6,
                          }}
                          key={item.title}
                          gap={"8px"}
                          display={"flex"}
                          flexDirection={"column"}
                        >
                          <Typography
                            variant="p"
                            color="#344054"
                            fontSize="15px"
                          >
                            {item.title}
                            <CustomizeSpan color={"red"}> *</CustomizeSpan>
                          </Typography>

                          {item.component === "input" && (
                            <Field name={item.titleName}>
                              {({ field, form }) => {
                                return (
                                  <CommonTextField
                                    type={item.type}
                                    CustomIcon={item.CustomIcon}
                                    placeholder={item.placeholder}
                                    padding="10px"
                                    error={Boolean(
                                      form.errors[item.titleName] &&
                                        form.touched[item.titleName]
                                    )}
                                    value={values[item.titleName]}
                                    onChange={(e) => {
                                      setFieldValue(
                                        item.titleName,
                                        e.target.value
                                      );
                                    }}
                                    helperText={
                                      Boolean(
                                        form.errors[item.titleName] &&
                                          form.touched[item.titleName]
                                      ) && form.errors[item.titleName]
                                    }
                                  />
                                );
                              }}
                            </Field>
                          )}

                          {item.component === "dropDown" && (
                            <Field name={item.titleName}>
                              {({ field, form }) => {
                                return (
                                  <DropDownSelect
                                    marginTop="0px"
                                    type={item.type}
                                    data={item.data}
                                    title={item.placeholder}
                                    padding="10px"
                                    error={Boolean(form.errors[item.titleName])}
                                    value={values[item.titleName]}
                                    handleChange={(e) => {
                                      setFieldValue(
                                        item.titleName,
                                        e.target.value
                                      );
                                    }}
                                    helperText={
                                      Boolean(form.errors[item.titleName]) &&
                                      form.errors[item.titleName]
                                    }
                                    removeAnimation={true}
                                    handleRenderValue={(selected) => {
                                      const data = item.data.find(
                                        (item) => item.value === selected
                                      );
                                      return data.name;
                                    }}
                                    valueChange={true}
                                    CustomMenuItem={CustomMenuItem}
                                    sizeMedium="-5px"
                                  />
                                );
                              }}
                            </Field>
                          )}

                          {item.component === "phone-number" && (
                            <Field name={item.titleName}>
                              {({ field, form }) => {
                                const isError = Boolean(
                                  form.touched[item.titleName] &&
                                    form.errors[item.titleName]
                                );
                                return (
                                  <>
                                    <CommonPhoneInput
                                      placeholder={item?.placeholder}
                                      padding="14px 0px 14px 60px"
                                      country="us"
                                      value={values[item.titleName]}
                                      onChange={(e, countryData) => {
                                        setFieldValue(
                                          item.country,
                                          countryData
                                        );
                                        setFieldValue(item.titleName, e);
                                      }}
                                    />
                                    {isError && (
                                      <ErrorContent
                                        margin="-2px 0px 0px"
                                        className="Mui-error"
                                      >
                                        {form.errors[item.titleName]}
                                      </ErrorContent>
                                    )}
                                  </>
                                );
                              }}
                            </Field>
                          )}
                        </CommonGrid2>
                      );
                    })}
                  </CommonGrid2>
                  <CommonGrid2 container spacing={2.5} marginTop={3}>
                    {passwordData?.map((item, index) => {
                      return (
                        <CommonGrid2
                          item
                          size={{
                            xs: 12,
                            md: 6,
                            sm: 6,
                          }}
                          key={item.title}
                          gap={"8px"}
                          display={"flex"}
                          flexDirection={"column"}
                        >
                          <Typography
                            variant="p"
                            color="#344054"
                            fontSize="15px"
                          >
                            {item.title}
                            <CustomizeSpan color={"red"}> *</CustomizeSpan>
                          </Typography>

                          {item.component === "input" && (
                            <Field name={item.titleName}>
                              {({ field, form }) => {
                                return (
                                  <CommonTextField
                                    type={item.type}
                                    CustomIcon={item.CustomIcon}
                                    placeholder={item.placeholder}
                                    padding="10px"
                                    error={Boolean(
                                      form.errors[item.titleName] &&
                                        form.touched[item.titleName]
                                    )}
                                    value={values[item.titleName]}
                                    onChange={(e) => {
                                      setFieldValue(
                                        item.titleName,
                                        e.target.value
                                      );
                                    }}
                                    helperText={
                                      Boolean(
                                        form.errors[item.titleName] &&
                                          form.touched[item.titleName]
                                      ) && form.errors[item.titleName]
                                    }
                                  />
                                );
                              }}
                            </Field>
                          )}
                        </CommonGrid2>
                      );
                    })}
                  </CommonGrid2>

                  <CommonGrid2 marginTop={"1rem"}>
                    <FormControlLabel
                      sx={{
                        color:
                          touched.rememberMe && errors.rememberMe && "#d32f2f",
                      }}
                      control={
                        <Checkbox
                          checked={values.rememberMe}
                          onChange={(e) =>
                            setFieldValue("rememberMe", e.target.checked)
                          }
                        />
                      }
                      label={
                        <CustomDiv>
                          I agree to the{" "}
                          <CustomizeSpan>Terms and Conditions</CustomizeSpan>
                        </CustomDiv>
                      }
                    />

                    {touched.rememberMe && errors.rememberMe && (
                      <Typography
                        color="error"
                        fontSize="11px"
                        marginTop="-0.5rem"
                        fontWeight={600}
                      >
                        {errors.rememberMe}
                      </Typography>
                    )}
                  </CommonGrid2>
                  <CommonGrid2
                    width={"100%"}
                    display={"flex"}
                    gap={"1rem"}
                    marginTop={"1rem"}
                  >
                    <CommonButton
                      value={"Back"}
                      width={"100%"}
                      padding={"10px"}
                      variant="outlined"
                      color="#344054"
                      fontWeight={"700"}
                      border={"#D0D5DD"}
                      onClick={() => navigate("/auth/login")}
                      disabled={buttonLoading.disabled}
                    />
                    <CommonButton
                      value={"Create"}
                      width={"100%"}
                      padding={"10px"}
                      type="submit"
                      disabled={buttonLoading.disabled}
                      loading={buttonLoading.createLoading}
                    />
                  </CommonGrid2>

                  <CommonGrid2
                    textAlign="center"
                    gap={"1rem"}
                    display={"flex"}
                    flexDirection={"column"}
                    marginTop={"2rem"}
                  >
                    {/* <Divider>
                      <Typography color={"#8396A8"}>Continue with</Typography>
                    </Divider>
                    <CommonButton
                      variant="outlined"
                      borderColor="#D5DADD"
                      value={"Sign up with Google"}
                      startIcon={<img src={GoogleLogo} alt="Google Logo" />}
                      width={"fit-content"}
                      margin={"auto"}
                      padding={"10px 2rem"}
                      disabled
                    /> */}

                    <CommonGrid2
                      display={"flex"}
                      flexDirection={"row"}
                      alignItems={"center"}
                      justifyContent={"center"}
                      gap={"5px"}
                    >
                      <Typography variant="subtitle1" color="text.secondary">
                        {"Already have an account ? "}
                      </Typography>
                      <Typography
                        variant="subtitle1"
                        color="primary"
                        sx={{
                          cursor: buttonLoading.disabled ? "auto" : "pointer",
                          opacity: buttonLoading.disabled ? 0.3 : 1,
                        }}
                        fontWeight={600}
                        onClick={() =>
                          buttonLoading.disabled ? {} : navigate("/auth/login")
                        }
                      >
                        {"Login"}
                      </Typography>
                    </CommonGrid2>
                  </CommonGrid2>
                </Form>
              );
            }}
          </Formik>
        </CommonGrid2>
      </CommonGrid2>
      <SnackBar
        snackbarState={snackbarState}
        handleCloseValidation={handleCloseValidation}
      />
    </Box>
  );
}
